import { inject, Injectable } from '@angular/core';
import { AsyncHttpClient } from './async-http-client.service';
import { AppId, ProductAttributeInstance } from '../../model';

@Injectable({ providedIn: 'root' })
export class ProductAttributeService {
  private http = inject(AsyncHttpClient);

  list = async (productId: AppId, elementId: AppId) =>
    this.http.get<ProductAttributeInstance[]>(`api/chain/${productId}/element/${elementId}/attribute`);

  create = async (productId: AppId, elementId: AppId, data: { definitionId: AppId; values?: Record<string, any> }) =>
    this.http.post<ProductAttributeInstance>(`api/chain/${productId}/element/${elementId}/attribute`, data);

  update = async (productId: AppId, elementId: AppId, instanceId: AppId, data: { values: Record<string, any> }) =>
    this.http.put<ProductAttributeInstance>(
      `api/chain/${productId}/element/${elementId}/attribute/${instanceId}`,
      data
    );

  delete = async (productId: AppId, elementId: AppId, instanceId: AppId) =>
    this.http.delete<void>(`api/chain/${productId}/element/${elementId}/attribute/${instanceId}`);
}
